import { axiosBaseInstance } from 'shared/utils/axios-instances';

const byokBaseEndpoint = '/byok';

export const BringYourOwnKeyService = {
  setOpenRouterApiKey: async (openRouterApiKey: string): Promise<void> => {
    const response = await axiosBaseInstance({
      method: 'post',
      url: `${byokBaseEndpoint}/open-router-api-key`,
      data: {
        openRouterApiKey
      }
    });

    return response.data;
  },

  getOpenRouterApiKey: async (): Promise<string> => {
    const response = await axiosBaseInstance({
      method: 'get',
      url: `${byokBaseEndpoint}/open-router-api-key`
    });

    return response.data;
  },

  unsetOpenRouterApiKey: async (): Promise<void> => {
    const response = await axiosBaseInstance({
      method: 'delete',
      url: `${byokBaseEndpoint}/open-router-api-key`
    });

    return response.data;
  }
};
